import {Action} from 'redux';

import {Place} from '../entities';
import {DuplicateScheduleForm} from '../entities/duplicateScheduleForm';
import {Scheduler} from '../entities/Scheduler';
import {SlotForm} from '../entities/slotForm';

export enum TSchedule {
  DISTRIBUTE_SCHEDULE = 'DISTRIBUTE_SCHEDULE',
  DISTRIBUTE_SCHEDULE24 = 'DISTRIBUTE_SCHEDULE24',
  FETCH_SCHEDULE = 'FETCH_SCHEDULE',
  FETCH_SCHEDULE_24 = 'FETCH_SCHEDULE_24',
  DUPLICATE_SCHEDULE = 'DUPLICATE_SCHEDULE',
  EDIT_SCHEDULE = 'EDIT_SCHEDULE',
}

export interface IDistibuteSchedule extends Action {
  type: TSchedule.DISTRIBUTE_SCHEDULE;
  payload: Scheduler;
}

export const ADistributeSchedule = (payload: Scheduler): IDistibuteSchedule => ({ type: TSchedule.DISTRIBUTE_SCHEDULE, payload });

export interface IFetchSchedule extends Action {
  type: TSchedule.FETCH_SCHEDULE;
}
export const AFetchSchedule = (): IFetchSchedule => ({ type: TSchedule.FETCH_SCHEDULE });

export interface IDistibuteSchedule24 extends Action {
  type: TSchedule.DISTRIBUTE_SCHEDULE24;
  payload: Place;
}

export const ADistributeSchedule24 = (payload: Place): IDistibuteSchedule24 => ({ type: TSchedule.DISTRIBUTE_SCHEDULE24, payload });

export interface IFetchSchedule24 extends Action {
  type: TSchedule.FETCH_SCHEDULE_24;
}

export const AFetchSchedule24 = (): IFetchSchedule24 => ({ type: TSchedule.FETCH_SCHEDULE_24 });

export interface IDuplicateSchedule extends Action {
  type: TSchedule.DUPLICATE_SCHEDULE;
  payload: any;
}

export const ADuplicateSchedule = (payload: DuplicateScheduleForm): IDuplicateSchedule => ({ type: TSchedule.DUPLICATE_SCHEDULE, payload });

export interface IEditSchedule extends Action {
  type: TSchedule.EDIT_SCHEDULE;
  payload: SlotForm[];
}

export const AEditSchedule = (payload: SlotForm[]): IEditSchedule => ({type: TSchedule.EDIT_SCHEDULE, payload});
